// extracted by mini-css-extract-plugin
export default {"catalogo_card":"catalogoCard_catalogo_card__pFFop","textoCentro":"catalogoCard_textoCentro__4H4DP","catalogo_info":"catalogoCard_catalogo_info__vxKl8"};